const pagesIndividualTasksEn = {
  pageTitle: "Task",
  progressLabels: {
    step: "Step Progress",
    task: "Task Progress",
  },
  navigateToHome: "Home",
  form: {
    validationError: "Input error: {{errorCount}} count",
  },
  qrScannerField: {
    initialState: {
      buttonText: "Take QR Code",
      description:
        "Point your camera at the QR code. Tap/click to launch camera",
      fallbackButton: "If QR code is unreadable",
    },
    scanningState: {
      fallbackButton: "If QR code is unreadable",
    },
    scannedState: {
      successMessage: "QR code successfully scanned",
      rescanButton: "Scan again",
    },
    manualInputState: {
      backToScanButton: "If you want to scan QR code",
    },
  },
  deviceInfoDisplay: {
    loading: "Retrieving device information...",
    error: {
      title: "Failed to retrieve data",
      fallback: "An error occurred",
    },
    notFound: "Device information not found",
  },
  deviceInventory: {
    title: "Device Inventory",
    selfReportSection: {
      title: "Self Report",
      description: "Report devices that are lent to you or that you manage.",
      taskTitle: "Submit Self Report",
    },
    completion: {
      title: "Task completed!",
      message: "What to do next...",
      nextTask: "Next Task",
      backToTaskList: "Back to Home",
      packageLabel: "Package",
      nextTaskLabel: "Proceed to next task",
    },
    errors: {
      noDeviceFound: "No device found",
    },
  },
  selfReport: {
    title: "Self Report",
    form: {
      deviceInfo: "Device Information",
      deviceId: "Device ID",
      assetTag: "Asset Management Tag",
      deviceStatus: {
        label: "Device Status",
        good: "Good",
        bad: "Not Good",
      },
      remarks: {
        label: "Remarks",
        placeholder: "Requests, etc.",
      },
    },
    submit: "Report",
    unavailableReport: "If you cannot report the target device",
    unavailableReportForm: {
      title: "If you cannot report the target device",
      reasonLabel: "Reason",
      reasons: {
        lost: "Lost the target device",
        unknown:
          "Have no knowledge of the management or lending of the target device",
      },
      submitButton: "Report",
      backButton: "Back",
    },
  },
  approvalDialog: {
    approvalFlow: "Approval Flow",
    approve: "Approve",
    noData: "No data available",
    error: "An error occurred",
  },
};

export default pagesIndividualTasksEn;
